<div [ngClass]="{'import-block__completed': !isActive() && stepState == ImportStepState.Completed, 'import-block__collapsed': !isActive() && stepState == ImportStepState.Available, 'import-block__not-available': stepState <= ImportStepState.NotAvailableYet, 'loading': dataLoading }"
    class="import-block">
    <div class="d-flex align-items-center">
        <div class="number-circle"><span [ngClass]="{'subtitle-2': stepState !== ImportStepState.Completed, 'material-icons-outlined': (stepState === ImportStepState.Completed && !isActive())}">{{
                (stepState === ImportStepState.Completed && !isActive()) ? 'check' : '5' }}</span></div>
        <h4>New & Lost</h4>
    </div>
    <ng-container *ngIf="!isActive() && stepState == ImportStepState.Completed">
        <div class="info-block">
            <span class="body-1">Strategy</span>
            <span *ngIf="shouldBreakDown && dataLoaded" class="body-1 text-900">Break down “New” and “Lost” under {{selectedColumn.name}}</span>
            <span *ngIf="!shouldBreakDown && dataLoaded" class="body-1 text-900">Do not break down “New” and “Lost”</span>
        </div>
        <div>
            <button (click)="editClick()" class="btn btn-secondary btn-icon btn-edit"><span class="material-icons-outlined">edit</span></button>
        </div>
    </ng-container>
    <ng-container *ngIf="isActive()">
        <div class="body-1 mb-16">Define a strategy for results that do not exist in both {{oldControlValue}} and {{newControlValue}}</div>
        <div class="radio-group separate-blocks">
            <label>
                <input type="radio" name="analysis" [value]="true" [(ngModel)]="shouldBreakDown">
                <div class="radio-option">
                    <div class="radio-circle"></div>
                    <div class="radio-content">
                        <span class="subtitle-1">Break down “New” and “Lost”</span>
                        <span class="body-2">If a result appears in {{newControlValue}} but not in {{oldControlValue}}, it counts as New variance. If it disappears in {{newControlValue}}, it counts as Lost variance.</span>
                    </div>
                </div>
            </label>
            <label>
                <input type="radio" name="analysis" [value]="false" [(ngModel)]="shouldBreakDown">
                <div class="radio-option">
                    <div class="radio-circle"></div>
                    <div class="radio-content">
                        <span class="subtitle-1">Do not break down “New” and “Lost”</span>
                        <span class="body-2">Results that exist only in {{oldControlValue}} or {{newControlValue}} are not marked as New or Lost.</span>
                    </div>
                </div>
            </label>
        </div>
    </ng-container>
    <ng-container *ngIf="shouldBreakDown && isActive()">
        <div class="body-1 mb-8">Break down “New” and “Lost” under {{selectedColumn.name}} - click on another component to change.</div>
        <div #tableContainer class="table-container column-border table-big">
            <!-- Header row -->
            <div class="row header">
                <div *ngFor="let col of columns" class="cell" (click)="selectColumn(col)" [ngClass]="{'inactive': !col.isEligible, 'selected': col.isSelected}">
                    <div class="subtitle-2">{{col.name}}</div>
                    <span class="body-2">{{ displayRoughNum(col.uniqueValues) }}</span>
                </div>
            </div>

            <!-- Data rows -->
            <div class="row">
                <div *ngFor="let col of columns" class="cell" [ngClass]="{'inactive': !col.isEligible, 'selected': col.isSelected}">
                    <ng-container *ngIf="col.someVals && col.someVals.length">
                        {{col.someVals[0]}}
                    </ng-container>
                </div>
            </div>
            <div class="row">
                <div *ngFor="let col of columns" class="cell" [ngClass]="{'inactive': !col.isEligible, 'selected': col.isSelected}">
                    <ng-container *ngIf="col.someVals && col.someVals.length > 1">
                        {{col.someVals[1]}}
                    </ng-container>
                </div>
            </div>
            <div class="row">
                <div *ngFor="let col of columns" class="cell" [ngClass]="{'inactive': !col.isEligible, 'selected': col.isSelected}">
                    <ng-container *ngIf="col.someVals && col.someVals.length > 2">
                        {{col.someVals[2]}}
                    </ng-container>
                </div>
            </div>
            <div class="row">
                <div *ngFor="let col of columns" class="cell" [ngClass]="{'inactive': !col.isEligible, 'selected': col.isSelected}">
                    <ng-container *ngIf="col.someVals && col.someVals.length > 3">
                        {{col.someVals[3]}}
                    </ng-container>
                </div>
            </div>
            <div class="row">
                <div *ngFor="let col of columns" class="cell" [ngClass]="{'inactive': !col.isEligible, 'selected': col.isSelected}">
                    <ng-container *ngIf="col.someVals && col.someVals.length > 4">
                        {{col.someVals[4]}}
                    </ng-container>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="isActive()">
        <div>
            <button (click)="save()" [ngClass]="{'loading-small':loading, 'btn':true}">Continue</button>
        </div>
    </ng-container>
</div>
